export default "__VITE_ASSET__C2WJfYw9__"